module.exports = __webpack_public_path__ + "media/images/flags/1x1/npl-65d5c79a8bfd0201497cb8d933951d52.svg";